import { Input } from 'components/atoms';
import { FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useTranslation } from 'react-i18next';
import { useGetCountries } from 'services/enums';
import { useStateStorage } from 'store/state';

const LabelSupervisorStep = () => {
  const { t } = useTranslation();

  const { countries: storeCountries } = useStateStorage();
  const { data: fetchedCountries } = useGetCountries(!storeCountries?.length);
  const countries = storeCountries?.length ? storeCountries : (fetchedCountries ?? []);

  const countrySelectOptions =
    countries?.map(country => ({
      label: t(`countries.${country.codeAlfa2}`),
      value: country.codeAlfa2,
    })) ?? [];

  return (
    <LabelFormStep
      header={t('label.form.supervisor.header')}
      description={t('label.form.supervisor.description')}>
      <Input.ComplexWrapper>
        <FormInput.Text
          name='legalSupervisorFirstName'
          label={t('input.label.firstName')}
        />
        <FormInput.Text
          name='legalSupervisorLastName'
          label={t('input.label.lastName')}
        />
      </Input.ComplexWrapper>
      <FormInput.Select
        name='legalSupervisorCountryAlfa2'
        label={t('input.label.country')}
          options={countrySelectOptions}
          wrapperClassName='max-w-full'
      />
      <FormInput.Text
        name='legalSupervisorPersonalId'
        label={t('input.label.personalId')}
        wrapperClassName='max-w-full'
      />
    </LabelFormStep>
  );
};

export default LabelSupervisorStep;
